import { render } from "./OperatingHours.vue?vue&type=template&id=3b689413"
import script from "./OperatingHours.vue?vue&type=script&lang=js"
export * from "./OperatingHours.vue?vue&type=script&lang=js"

import "./OperatingHours.vue?vue&type=style&index=0&id=3b689413&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__